import { render, staticRenderFns } from "./DaftarArsip.vue?vue&type=template&id=bcff76ee&"
import script from "./DaftarArsip.vue?vue&type=script&lang=js&"
export * from "./DaftarArsip.vue?vue&type=script&lang=js&"
import style0 from "./DaftarArsip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports